import { useContext } from "react";

// modules
import { FormattedMessage } from "react-intl";

// contexts
import { PlayerContext } from "../../../contexts/PlayerContext";

// mui
import { Box, Typography } from '@mui/material';


export const ListenLabel = () => {
    const playerContext = useContext(PlayerContext);

    const { style } = playerContext;
    const { visual } = style;
    const { primaryColor } = visual;
    const { customListenLabel } = visual;
    const labelLength = customListenLabel.length;

    return (
        <Box
            sx={{
                backgroundColor: labelLength < 10 ? `${primaryColor}` : 'transparent',
                borderRadius: '3px',
                display: 'flex',
                px: '3px',
            }}
        >
            <Typography
                variant="caption"
                noWrap
                sx={{
                    background: 'inherit',
                    backgroundClip: 'text',
                    color: labelLength < 10 ? 'transparent' : `${primaryColor}`,
                    filter: labelLength < 10 ? 'invert(1) grayscale(1) contrast(9)' : '',
                    fontStyle: labelLength < 10 ? 'normal' : 'italic',
                    fontWeight: 600,
                    opacity: 1
                }}
            >
                {customListenLabel && customListenLabel !== '' ? (
                    customListenLabel
                ) : (
                    <FormattedMessage id='app.player-listen-label' />
                )}

            </Typography>
        </Box>
    )
}
